module.exports = __webpack_public_path__ + "static/media/allImpact_60yd_n-1.69c4498d.csv";